const appConfig = {
    apiPrefix: process.env.REACT_APP_BACKEND_BASE_URL,
    paymentApiPrefix: process.env.REACT_APP_BACKEND_BASE_URL.replace(/\/admin$/, '/payment'),
    frontendBaseUrl: process.env.REACT_APP_FRONTEND_BASE_URL,
    authenticatedEntryPath: '/app/crm/organizer/2',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    locale: 'en',
    enableMock: false,
}

export default appConfig
